import React from 'react';
import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import moment from 'moment';
import {useDispatch} from 'react-redux';
import {getCreditPosts, deleteCreditPost} from '../../../actions/creditposts';
import {Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: 'purple',
  },
}));




const CreditPost = ({post, setCurrentId, pageNumber}) =>{
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('profile'));
  const [expanded, setExpanded] = React.useState(false);

  
  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar} >
          {post.name[0]}{post.name.split(" ")[1][0]}
          </Avatar> 
        }
        action={
          <IconButton aria-label="settings">
            {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
            <div  className = {classes.overlay2}>
                <Button style = {{color : 'black'}}  size = "small" onClick = {()=> setCurrentId(post._id)}>
                    <MoreHorizIcon  fontSize = "default" />    
                </Button>
            </div>
            )}
          </IconButton>
        }
        title ={post.prediction}
        subheader= {moment(post.createdAt).fromNow()}
        >  
      </CardHeader>
      <CardMedia
        className={classes.media}
        image={post.prediction === "High Chance"? "https://pixy.org/src/67/672332.jpeg": "https://t4.ftcdn.net/jpg/03/29/86/73/360_F_329867305_wRwyoJbPH0QNoLgmXqfQRYzpz7lTl7OY.jpg"}
        title={post.prediction}
      />
      <CardContent>
        <Typography variant="body2" color="textPrimary" component="p">
          Total Income: {post.income}    
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Family Members: {post.familyNumber}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Children: {post.children} 
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Days Employed: {post.employed} 
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Gender: {post.gender === "1" ? "Male" : "Female"}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Car: {post.car === "1" ? "Yes" : "No"}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Realty: {post.realty === "1" ? "Yes" : "No"}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Income: {post.incomeType === "0" ? "Type A" :
          ( post.incomeType === "1" ? "Type B" : 
          ( post.incomeType === "2" ? "Type C" : 
          ( post.incomeType === "3" ? "Type D" : "Type E")))}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Education: {post.educationType === "0" ? "Type A" :
          ( post.educationType === "1" ? "Type B" : 
          ( post.educationType === "2" ? "Type C" : 
          ( post.educationType === "3" ? "Type D" : "Type E")))}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Housing: {post.housingType === "0" ? "Type A" :
          ( post.housingType === "1" ? "Type B" : 
          ( post.housingType === "2" ? "Type C" : 
          ( post.housingType === "3" ? "Type D" : 
          ( post.housingType === "4" ? "Type E" : "Type E" ))))}
        </Typography>
        <Typography variant="body2" color="textPrimary" component="p">
          Possibility: {post.probability}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
        <div>
          <Grid
            item
            container
            direction="row"
            justify="flex-end"
          >
            <Button size="small" color="secondary" onClick={() => {
              dispatch(deleteCreditPost(post._id))
              dispatch(getCreditPosts(pageNumber))
              dispatch(getCreditPosts(pageNumber))}}>
              <DeleteIcon fontSize="small" /> 
              Delete
            </Button>
          </Grid>
        </div>
        )} 
      </CardActions>
    </Card>
  );
};

export default CreditPost;

